import { gql } from '@apollo/client';

export const GET_AIR_DATA_OF_ALL_GROUPS = gql`
  query q($orgId: String!) {
    org(id: $orgId) {
      id
      name
      locations {
        id
        name
        averageScore
        averageSensorValues {
          averageValue
          component
        }
        averageSensorIndices {
          averageIndex
          component
        }
      }
    }
  }
`;
// export const GET_AIR_DATA_OF_ALL_GROUPS = gql`
//   query orgs($orgId: Int!, $from: DateTime!, $to: DateTime!) {
//     organization(orgId: $orgId) {
//       allGroups {
//         groupId
//         name
//         averageScore(from: $from, to: $to, downsampler: none, limit: 1, desc: true) {
//           averageValue
//         }
//         averageSensorValues(
//           from: $from
//           to: $to
//           downsampler: none
//           limit: 1
//           desc: true
//           airDataLimitDirection: { limit: 8, direction: descending }
//         ) {
//           averageValue
//           component
//         }
//         averageSensorIndices(
//           from: $from
//           to: $to
//           downsampler: none
//           limit: 1
//           desc: true
//           airDataLimitDirection: { limit: 8, direction: descending }
//         ) {
//           averageIndex
//           component
//         }
//       }
//     }
//   }
// `;



// WEBPACK FOOTER //
// ./src/app/afb-graphql-api/gqls/air-data-poll.gql.ts